import * as d3 from 'd3';
import { IResizable } from './IResizable';

export abstract class ResizableBase {
    private _group: d3.Selection<any>;
    private _children: IResizable[];

    constructor(container: d3.Selection<any>, classed: string) {
        this._group = container
            .append('g')
            .classed(classed, true);
        this._children = [];
    }

    group(): d3.Selection<any> {
        return this._group;
    }

    children(): IResizable[] {
        return this._children;
    }

    resize(width: number, height: number, obj: IResizable): void {
    }

    add(child: IResizable): void {
        this._children.push(child);
    }
}
